export enum Wheather {
  EXTRASUNNY,
  CLEAR,
  CLOUDS,
  SMOG,
  FOGGY,
  OVERCAST,
  RAIN,
  THUNDER,
  CLEARING,
  NEUTRAL,
  SNOW,
  BLIZZARD,
  SNOWLIGHT,
  XMAS,
  HALLOWEEN,
  RAIN_HALLOWEEN,
  SNOW_HALLOWEEN,
}

export enum Weapon {
  Machinepistol = "Machinepistol", // пистолет-пулемет
  Pistol = "Pistol", // пистолет
  Sawnoffshotgun = "Sawnoffshotgun", // обрез
  Pumpshotgun = "Pumpshotgun", // дробовик
  Rpg = "Rpg", // рпг
  Grenadelauncher = "Grenadelauncher", // гранатомет
  Sniperrifle = "Sniperrifle", // снайперка
  Unarmed = "Unarmed", // безоружия
  Machine = "Machine",
  Rifle = "Rifle",
}

export const dayOfWeek = {
  1: "ПН",
  2: "ВТ",
  3: "СР",
  4: "ЧТ",
  5: "ПТ",
  6: "СБ",
  7: "ВС",
};

// TODO: убрать в локализацию
export const wheather: Record<Wheather, string> = {
  [Wheather.EXTRASUNNY]: "Экстрасолнечно",
  [Wheather.CLEAR]: "Ясно",
  [Wheather.CLOUDS]: "Облачно",
  [Wheather.SMOG]: "Смог",
  [Wheather.FOGGY]: "Туман",
  [Wheather.OVERCAST]: "Облачно",
  [Wheather.RAIN]: "Дождь",
  [Wheather.THUNDER]: "Гром",
  [Wheather.CLEARING]: "Ясно",
  [Wheather.NEUTRAL]: "Нейтрально",
  [Wheather.SNOW]: "Снег",
  [Wheather.BLIZZARD]: "Метель",
  [Wheather.SNOWLIGHT]: "Легкий снег",
  [Wheather.XMAS]: "Рождество",
  [Wheather.HALLOWEEN]: "Хэллоуин",
  [Wheather.RAIN_HALLOWEEN]: "Дождливый хэлл.",
  [Wheather.SNOW_HALLOWEEN]: "Снежный хэлл.",
};

export const weapon: Record<Weapon, string> = {
  [Weapon.Machine]: "Автомат",
  [Weapon.Rifle]: "Винтовка",
  [Weapon.Machinepistol]: "Пистолет-пулемет",
  [Weapon.Pistol]: "Пистолет",
  [Weapon.Sawnoffshotgun]: "Обрез",
  [Weapon.Pumpshotgun]: "Дробовик",
  [Weapon.Rpg]: "РПГ",
  [Weapon.Grenadelauncher]: "Гранатомет",
  [Weapon.Sniperrifle]: "Снайперка",
  [Weapon.Unarmed]: "Без оружия",
};
